/* Infused Lights email list opt in (Part 118, Oct 4, 2026).
   Any form with data-il-optin="<source tag>" that has a contact[email] field gets a pre checked
   "Also send me Infused Lights updates and offers" checkbox right above its submit button.
   Checked on submit: the email is first posted with Shopify's customer form (form_type customer,
   tags newsletter + the source tag) into a hidden frame, through Shopify's own form protection,
   then the original form is sent exactly as before. Unchecked: only the original form is sent.
   contact[Email list] = Yes / No is added to the original submission so the inbox shows the choice. */
(function(){
  if(window.__ilOptin) return; window.__ilOptin=true;
  var LABEL='Also send me Infused Lights updates and offers (you can unsubscribe anytime)';
  var FAIL='Yes, but the automatic signup did not finish, please add by hand';
  var n=0;
  var css='.il-optin{display:flex!important;gap:.7rem;align-items:flex-start;margin:.85rem 0 .9rem!important;padding:.8rem .9rem!important;border-radius:10px;border:1px solid rgba(216,184,106,.75);background:rgba(216,184,106,.12);text-align:left;box-sizing:border-box;max-width:100%}'+
    '.il-optin input[type=checkbox].il-optin__box{-webkit-appearance:checkbox!important;appearance:auto!important;position:static!important;opacity:1!important;display:inline-block!important;width:22px!important;height:22px!important;min-width:22px!important;margin:.1rem 0 0!important;padding:0!important;flex:none;accent-color:#c9a24a;cursor:pointer;visibility:visible!important}'+
    '.il-optin label.il-optin__label{display:block!important;margin:0!important;padding:0!important;text-transform:none!important;letter-spacing:0!important;font-size:16px!important;line-height:1.45!important;font-weight:600!important;cursor:pointer;opacity:1!important;white-space:normal!important}'+
    '.il-optin-hidden{position:absolute!important;width:1px!important;height:1px!important;margin:-1px!important;padding:0!important;border:0!important;overflow:hidden!important;clip:rect(0 0 0 0)!important;clip-path:inset(50%)!important;white-space:nowrap!important}';
  function addCss(){ if(document.getElementById('il-optin-css')) return; var s=document.createElement('style'); s.id='il-optin-css'; s.textContent=css; (document.head||document.documentElement).appendChild(s); }
  function el(tag,attrs){ var e=document.createElement(tag); for(var k in attrs){ if(k==='text') e.textContent=attrs[k]; else e.setAttribute(k,attrs[k]); } return e; }
  function enhance(f){
    if(f.__ilOptin || f.getAttribute('data-il-optin-ready')) return;
    var key=(f.getAttribute('data-il-optin')||'').replace(/[^a-z0-9-]/gi,'').toLowerCase();
    var email=f.querySelector('input[name="contact[email]"]');
    var btn=f.querySelector('button[type=submit],input[type=submit]');
    if(!key||!email||!btn) return;
    addCss(); n++;
    var id='il-optin-'+key+'-'+n, frameName='il-optin-frame-'+n;
    var val=el('input',{type:'hidden',name:'contact[Email list]',value:'Yes'});
    var wrap=el('div',{'class':'il-optin'});
    var box=el('input',{type:'checkbox',id:id,'class':'il-optin__box'}); box.checked=true; box.defaultChecked=true;
    var lab=el('label',{'for':id,'class':'il-optin__label',text:LABEL});
    wrap.appendChild(box); wrap.appendChild(lab);
    /* Right above the button; if the button sits in a flex or grid row, above that row instead. */
    var anchor=btn;
    while(anchor.parentNode && anchor.parentNode!==f){ var d=getComputedStyle(anchor.parentNode).display; if(!/flex|grid/.test(d)) break; anchor=anchor.parentNode; }
    anchor.parentNode.insertBefore(val,anchor); anchor.parentNode.insertBefore(wrap,anchor);
    var sub=el('form',{method:'post',action:'/contact#il_optin',"accept-charset":'UTF-8',target:frameName,'class':'il-optin-hidden','aria-hidden':'true','data-il-optin-sub':key});
    sub.appendChild(el('input',{type:'hidden',name:'form_type',value:'customer'}));
    sub.appendChild(el('input',{type:'hidden',name:'utf8',value:'\u2713'}));
    var extra=(f.getAttribute('data-il-optin-extra-tags')||'').replace(/[^a-z0-9,-]/gi,'').toLowerCase();
    sub.appendChild(el('input',{type:'hidden',name:'contact[tags]',value:'newsletter,'+key+(extra?','+extra:'')}));
    var subEmail=el('input',{type:'email',name:'contact[email]',tabindex:'-1',autocomplete:'off'});
    sub.appendChild(subEmail);
    var frame=el('iframe',{name:frameName,title:'Email list signup','class':'il-optin-hidden',tabindex:'-1','aria-hidden':'true',sandbox:'allow-same-origin allow-forms'});
    document.body.appendChild(sub); document.body.appendChild(frame);
    var st={f:f,box:box,val:val,sub:sub,subEmail:subEmail,frame:frame,btn:btn,state:'idle'};
    f.__ilOptin=st; f.setAttribute('data-il-optin-ready','1');
    function sync(){ val.value=box.checked?'Yes':'No'; }
    box.addEventListener('change',sync); sync();
    f.addEventListener('focusin',function(){ warm(st); });
  }
  function warm(st){ if(st.warm) return; st.warm=true; try{ st.subEmail.dispatchEvent(new Event('change',{bubbles:true})); }catch(e){} }
  function bound(sub){ return sub.hasAttribute('data-hcaptcha-bound')||sub.hasAttribute('data-recaptcha-bound'); }
  function challengeOpen(){
    var fs=document.querySelectorAll('iframe[src*="hcaptcha"]');
    for(var i=0;i<fs.length;i++){ var r=fs[i].getBoundingClientRect(); if(r.height>100 && r.width>100){ var v=true; for(var p=fs[i];p&&p.nodeType===1;p=p.parentElement){ var cs=getComputedStyle(p); if(cs.visibility==='hidden'||cs.display==='none'||cs.opacity==='0'){ v=false; break; } } if(v) return true; } }
    return false;
  }
  function sendOriginal(st){
    st.state='done';
    var f=st.f;
    if(typeof f.requestSubmit==='function'){ try{ f.requestSubmit(st.btn); return; }catch(e){ try{ f.requestSubmit(); return; }catch(e2){} } }
    var ev; try{ ev=new Event('submit',{bubbles:true,cancelable:true}); }catch(e){}
    if(!ev || f.dispatchEvent(ev)) f.submit();
  }
  window.addEventListener('submit',function(ev){
    var f=ev.target, st=f&&f.__ilOptin;
    if(!st) return;
    if(st.state==='done'){ st.state='idle'; return; }
    st.val.value=st.box.checked?'Yes':'No';
    if(!st.box.checked) return;
    ev.preventDefault(); ev.stopImmediatePropagation();
    if(st.state==='busy') return;
    st.state='busy';
    var em=f.querySelector('input[name="contact[email]"]'); st.subEmail.value=em?em.value.trim():'';
    var started=Date.now(), finished=false;
    if(st.btn) st.btn.setAttribute('aria-busy','true');
    function finish(ok){
      if(finished) return; finished=true;
      if(!ok) st.val.value=FAIL;
      if(st.btn) st.btn.removeAttribute('aria-busy');
      sendOriginal(st);
    }
    st.frame.onload=function(){ var ok=false; try{ ok=/customer_posted=true/.test(st.frame.contentWindow.location.href); }catch(e){} finish(ok); };
    (function watchdog(){ if(finished) return; var t=Date.now()-started; if(t>=20000 && (!challengeOpen() || t>=180000)) return finish(false); setTimeout(watchdog,1000); })();
    warm(st);
    var tries=0;
    (function go(){ if(bound(st.sub)||tries>=25){ try{ st.sub.submit(); }catch(e){ finish(false); } return; } tries++; setTimeout(go,200); })();
  },true);
  function scan(root){ var fs=(root||document).querySelectorAll('form[data-il-optin]'); for(var i=0;i<fs.length;i++) enhance(fs[i]); }
  function init(){
    scan();
    if(window.MutationObserver){ var t=null; new MutationObserver(function(){ if(t) return; t=setTimeout(function(){ t=null; scan(); },150); }).observe(document.body,{childList:true,subtree:true}); }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
